export default "__VITE_ASSET__C54Eqi12__"